"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarAppSwitcher = void 0;
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const svgs_1 = require("../assets/svgs");
function NavBarAppSwitcher({ sx, children, ...rest }) {
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const defaultSX = {
        width: '2.5rem',
        height: '2.5rem',
        display: 'flex',
        alignItems: 'center',
        minWidth: '2.5rem',
        padding: '0px',
        margin: '0px',
    };
    const mergedSX = { ...defaultSX, ...sx };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Button, { sx: mergedSX, onClick: handleClick, ...rest },
            react_1.default.createElement(svgs_1.AppSwitcher, null)),
        react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, open: isOpen, onClose: handleClose, sx: {
                '.MuiPaper-root': {
                    borderRadius: '0.5rem',
                },
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } },
            react_1.default.createElement("div", { className: "grid grid-cols-2 px-[1rem] py-[0.5rem] gap-[2rem]" }, react_1.default.Children.toArray(children)
                .filter(react_1.isValidElement)
                .map((child, index) => {
                return (react_1.default.createElement("div", { key: index, onClick: handleClose }, child));
            })))));
}
exports.NavBarAppSwitcher = NavBarAppSwitcher;
